import React, { Component } from "react";
import {
  FormInput,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Button,
} from "shards-react";

export class SearchInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      queryStr: "",
    };
  }

  handleChange = (event) => {
    this.setState({
      queryStr: event.target.value,
    });
  };

  keyPress = (event) => {
    if (event.key === "Enter") {
      this.props.updateQueryStr(this.state.queryStr);
    }
  };

  render() {
    return (
      <InputGroup seamless>
        <InputGroupAddon type="prepend">
          <InputGroupText>
            <i className="material-icons">search</i>
          </InputGroupText>
        </InputGroupAddon>
        <FormInput
          placeholder="Chercher par Nom ou Prénom EXACT"
          onChange={this.handleChange}
          onKeyPress={this.keyPress}
        />
        <Button
          theme="info"
          className="ml-1"
          onClick={() => this.props.updateQueryStr(this.state.queryStr)}
        >
          Search
        </Button>
      </InputGroup>
    );
  }
}

export default SearchInput;
